module.exports = __webpack_public_path__ + "static/media/dropdown.c5973145.svg";